module.exports = {
      id: "face-frown-icon-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#face-frown-icon",
      toString: function () {
        return this.url;
      }
    }